import { ICharge } from "../../types/charge.type";
import { ITrafficFine, TRAFFICFINE_STATUS } from "../../types/trafficfine.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

export type TrafficFinesChangeUpdateFile = {
  _id: string | undefined;
  url: string | undefined;
  barcode: string;
};

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export type ChargeStatusSummary = Record<
  string,
  { count: number; totalValue: number }
>;

export type TrafficFineStatusSummaryRow = {
  status?: TRAFFICFINE_STATUS | string;
  _id?: { status?: string } | string;
  totalValue: number;
};

export type TrafficFinesPartnerScope =
  | "all"
  | "management_enabled"
  | "locavibe";

export async function getTrafficFines({
  status = [],
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  startDateTrafficFine = "",
  endDateTrafficFine = "",
  startDueDateTrafficFine = "",
  endDueDateTrafficFine = "",
  page = 1,
  itemsPerPage = "",
  // orderBy = "-date",
  fleetManagementGroup = "",
  partnerId = "",
  partnerScope = "all",
  paymentTrafficfine = "",
  gravity = "",
  fields = "licensePlate, date, value, trafficTicket, partner, renter, status, details, attached, payment, createdAt, updatedAt, gravity",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }

  const filters: Record<string, string> = {
    "filters[status]": statusParam,
    "filters[gravity]": gravity,
    search: search,
    "filters[startDate]": startDate,
    "filters[endDate]": endDate,
    "filters[startDateAtualizadoEm]": startDateAtualizadoEm,
    "filters[endDateAtualizadoEm]": endDateAtualizadoEm,
    "filters[startDateTrafficFine]": startDateTrafficFine,
    "filters[endDateTrafficFine]": endDateTrafficFine,
    "filters[startDueDateTrafficFine]": startDueDateTrafficFine,
    "filters[endDueDateTrafficFine]": endDueDateTrafficFine,
    "filters[paymentTrafficfine]": paymentTrafficfine,
    "[partnerId]": partnerId,
    partnerScope,
    fleetManagementGroup: fleetManagementGroup,
    orderBy: "-date",
  };

  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.append(key, value);
  });

  const url = `${API_URL}/reports/trafficfines?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<ITrafficFine[]> & {
      totalItems: number;
      totalizer: number;
      statusCharge: ChargeStatusSummary;
      managementStatusCharge: ChargeStatusSummary;
      statusInfracoes: TrafficFineStatusSummaryRow[];
    }
  >;
  const response = await result;

  return {
    ok: response.ok,
    message: response.message,
    data: response.data,
    totalItems: response.totalItems,
    totalizer: response.totalizer,
    statusCharge: response.statusCharge,
    managementStatusCharge: response.managementStatusCharge,
    statusInfracoes: response.statusInfracoes,
  };
}

export async function getDetailsTrafficFines(trafficTicket) {
  const url = `${API_URL}/reports/trafficfines/${trafficTicket}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<{ trafficFine: ITrafficFine; charge: ICharge }>
  >;

  return (await result).data;
}

export async function chargeTrafficFine(trafficTicket) {
  const url = `${API_URL}/reports/trafficfines/${trafficTicket}/charge`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };

  const result = await makeRequestDebounced(url, options);

  return result as Promise<ApiResponseType<{ charge: ICharge }>>;
}

export async function updateTrafficFine(
  trafficTicket,
  params: Partial<ITrafficFine>
) {
  const url = `${API_URL}/reports/trafficfines/${trafficTicket}/update-renter`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  };
  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ITrafficFine>
  >;
}

export async function handleFileChangeUpdate(
  params: TrafficFinesChangeUpdateFile
): Promise<ApiResponseType<unknown>> {
  const url = `${API_URL}/reports/trafficfines/upload-barcode`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  };

  return (await makeRequestDebounced(url, options)) as ApiResponseType<unknown>;
}
